import ResponsiveTable from './ResponsiveTable';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Pagination from '@material-ui/lab/Pagination';
import { CircularProgress } from '@material-ui/core';
import { BsFillEyeFill } from 'react-icons/bs';
import { MdFileDownload } from 'react-icons/md';
import Search from './Search';
import './MeetingRecordings.css';

export default function MeetingRecordings({ endpoint, request, candidateView = false, interviewView = false }) {
  const [result, setResult] = useState({ items: [], pagination: { last_page: 1 } });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const [selected, setSelected] = useState(null);
  const [playbackError, setPlaybackError] = useState('');
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    if (search === query) return;
    const timer = setTimeout(() => { setQuery(search); setPage(1); }, 350);
    return () => clearTimeout(timer);
  }, [search, query]);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(''); setSelected(null);
    const load = async () => {
      try {
        const response = await request(`${endpoint}?page=${page}&search=${encodeURIComponent(query)}`);
        if (!active) return;
        if (!response || !response.items) throw new Error(response?.message || 'Não foi possível carregar as gravações.');
        setResult(response); setLoading(false);
      } catch (e) { if (active) { setError(e.message); setLoading(false); } }
    };
    load();
    const timer = setInterval(load, 10000);
    return () => { active = false; clearInterval(timer); };
  }, [endpoint, request, page, query, refresh]);
  const generate = async row => {
    const key = `${row.user_id}-${row.fiscal_id}`; setBusy(key); setError('');
    try {
      const id = candidateView ? row.fiscal_id : row.user_id;
      const job = await request(`${endpoint}/${id}`, 'POST');
      if (!job || !job.id) throw new Error(job?.message || 'Não foi possível iniciar a geração.');
      if (job.download_url) {
        const anchor = document.createElement('a'); anchor.href = job.download_url;
        anchor.download = `gravacao-${row.user_id}-${row.fiscal_id}.mp4`; anchor.rel = 'noopener';
        document.body.appendChild(anchor); anchor.click(); anchor.remove();
      }
      setRefresh(value => value + 1);
    } catch (e) { setError(e.message); }
    finally { setBusy(null); }
  };
  const status = job => !job ? 'Não gerada' : String(job.status) === '2' ? 'Disponível' : String(job.status) === '3' ? 'Falha na geração' : String(job.status) === '1' ? `Gerando (${job.progress || 0}/${job.total || 1})` : 'Na fila';
  return <section className="meeting-recordings" aria-label="Gravações de chamadas">
    <div className="row meeting-recordings-toolbar hidethis"><Search placeholder={`Pesquisar pelo nome do ${candidateView ? (interviewView ? 'avaliador' : 'fiscal') : 'candidato'}`} ValueChange={value => setSearch(value.slice(0, 250))} /></div>
    {error && <div className="alert alert-danger" role="alert">{error} <button className="btn btn-sm btn-outline-danger" onClick={() => setRefresh(v => v + 1)}>Atualizar</button></div>}
    {loading ? <div className="meeting-recordings-loading" role="status" aria-label="Carregando gravações"><CircularProgress /></div> : <>
      {!result.items.length && <p>Nenhuma chamada com gravação encontrada.</p>}
      {!!result.items.length && <div className="table-rep-plugin"><div className="table-responsive"><ResponsiveTable className="table table-striped"><thead><tr><th>{candidateView ? (interviewView ? 'Avaliadores' : 'Fiscal') : 'Candidato'}</th><th>Último trecho</th><th>Situação</th><th className="hidethis">Ações</th></tr></thead>
        <tbody>{result.items.map(row => {
          const key = `${row.user_id}-${row.fiscal_id}`;
          const pending = row.job && ['0', '1'].includes(String(row.job.status));
          const downloadLabel = busy === key ? 'Aguarde…' : row.job?.stale ? 'Atualizar download' : row.job?.url ? 'Download' : 'Gerar download';
          return <tr key={key}><td>{(candidateView && interviewView ? row.participants?.map(person => person.name).join(' · ') : (candidateView ? row.fiscal : row.user)?.name) || 'Usuário indisponível'}</td><td>{row.last_recorded_at ? new Date(row.last_recorded_at).toLocaleString('pt-BR') : '—'}</td>
            <td><span className={`badge ${!row.job ? 'badge-secondary' : String(row.job.status) === '2' ? 'badge-success' : String(row.job.status) === '3' ? 'badge-danger' : 'badge-warning'}`}>{status(row.job)}</span>{row.job?.error && <small className="d-block">{row.job.error}</small>}</td><td className="hidethis">
              <div className="meeting-recordings-actions hidethis">
                <button type="button" className="inline-flex align-center jcc bg-warning icon" title="Ver gravação" aria-label="Ver gravação" disabled={!row.job?.url} onClick={() => { setPlaybackError(''); setSelected({ url: row.job.url, candidate: row.user?.name, fiscal: interviewView ? row.participants?.map(person => person.name).join(' · ') : row.fiscal?.name }); }}><BsFillEyeFill size={17} color="white" /></button>
                <button type="button" className="inline-flex align-center jcc bg-info icon" title={downloadLabel} aria-label={downloadLabel} disabled={pending || busy === key} onClick={() => generate(row)}>{busy === key ? <span className="spinner-border spinner-border-sm" aria-hidden="true" /> : <MdFileDownload size={17} color="white" />}</button>
              </div>
            </td></tr>;
        })}</tbody></ResponsiveTable></div></div>}
      {result.pagination.last_page > 1 && <Pagination className="meeting-recordings-pagination hidethis" count={result.pagination.last_page} page={page} onChange={(_, value) => setPage(value)} />}
    </>}
    {selected && <Modal show centered className="meeting-recording-modal" dialogClassName="meeting-recording-dialog" aria-labelledby="meeting-recording-title" onHide={() => setSelected(null)}>
      <Modal.Header closeButton closeLabel="Fechar gravação">
        <div>
          <Modal.Title id="meeting-recording-title">Gravação da chamada</Modal.Title>
          <p className="meeting-recording-participants">{selected.candidate || 'Candidato'} <span aria-hidden="true">·</span> {selected.fiscal || (interviewView ? 'Avaliadores' : 'Fiscal')}</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        {playbackError && <div className="alert alert-danger" role="alert">{playbackError}</div>}
        <video className="meeting-recording-player" aria-label="Vídeo da chamada" controls playsInline preload="metadata" src={selected.url} onError={() => setPlaybackError('Não foi possível reproduzir o MP4. Feche o vídeo e atualize a listagem.')} />
      </Modal.Body>
    </Modal>}
  </section>;
}
